import React from "react";
import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { About } from "../components/About";
import { Advantages } from "../components/Advantages";
import { Commission } from "../components/Commission";
import { Journey } from "../components/Journey";
import { ContactSection } from "../components/ContactSection";
import { Footer } from "../components/Footer";
export function Recruitment() {
  return <div className="min-h-screen w-full bg-paper font-sans text-ink" data-id="element-204" data-mp="3mcl75a5hk3bl">
      <Header data-id="element-205" data-mp="3hjryib6wcau8" />
      <main data-id="element-206" data-mp="3hiyxlqumcfk0">
        <Hero data-id="element-207" data-mp="3higv4chd553n" />
        <About data-id="element-208" data-mp="3clgp21kik2cj" />
        <Advantages data-id="element-209" data-mp="3cl76v05pmzhe" />
        <Commission data-id="element-210" data-mp="3cmicz6mmojbo" />
        <Journey data-id="element-211" data-mp="3cm06lh694oq1" />
        <ContactSection data-id="element-212" data-mp="3cje2xsmhetd3" />
      </main>
      <Footer data-id="element-213" data-mp="37mvzqx6sv32v" />
    </div>;
}